import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";

import { MenuSliderComponent } from "./menu-slider/menu-slider.component";
import { PinVerificationComponent } from "./pin-verification/pin-verification.component";
import { WholeScreenNotificationComponent } from "./whole-screen-notification-component/whole-screen-notification-component.component";
import { ProfileImageComponent } from "./profile-image/profile-image.component";
import { AbComponentComponent } from "./ab-component/ab-component.component";
import { TranslateModule } from "@ngx-translate/core";
import { BrowserMessageComponent } from "./browser-message/browser-message.component";
import { SafeHtmlPipe } from "../pipes/safe-html.pipe";
import { ucFirstPipe } from "../pipes/ucfirst.pipe";
import { FavoriteNewsArticleComponent } from "./favorite-news-article/favorite-news-article.component";
import { AppFormComponent } from "./app-form/app-form.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { UnreadBadgeComponent } from "./unread-badge/unread-badge.component";

@NgModule({
    declarations: [
        MenuSliderComponent,
        WholeScreenNotificationComponent,
        PinVerificationComponent,
        ProfileImageComponent,
        AbComponentComponent,
        BrowserMessageComponent,
        SafeHtmlPipe,
        ucFirstPipe,
        FavoriteNewsArticleComponent,
        AppFormComponent,
        UnreadBadgeComponent
    ],
    imports: [CommonModule, IonicModule, TranslateModule, AngularSvgIconModule],
    exports: [
        MenuSliderComponent,
        WholeScreenNotificationComponent,
        FavoriteNewsArticleComponent,
        PinVerificationComponent,
        ProfileImageComponent,
        AbComponentComponent,
        BrowserMessageComponent,
        SafeHtmlPipe,
        ucFirstPipe,
        AppFormComponent,
        UnreadBadgeComponent
    ]
})
export class ComponentModule {}
